import "./PageTransition.css";

export default function PageTransition({ children }) {
  return <div className="page-transition-content">{children}</div>;
}
